import Icon from "@Atom/Icon";

import UseOutsideClick from "@Hooks/useOutsideClick";
import { useEffect, useMemo, useRef, useState } from "react";
import Styles from "./styles.module.scss";

export default function NewAutoComplete({
  value = "",
  setValue = () => {},
  options = [],
  placeholder,
  disabled,
  viewOnly,
  valueLabel = "",
  forceValue = false,
  onClickOption = () => {},
  onKeyDown = () => {},
  selectedItem = [],
  onReset = () => {},
  isError = false,
  isErrorText = "Please fill the field",
  onResetAll = () => {},
  maxHeight = "",
}) {
  const [expandOptions, setExpandOptions] = useState(false);

  // const activateDropdown = () => {
  //   if (!disabled || !viewOnly) {
  //     setExpandOptions(!expandOptions);
  //   }
  // };

  const boxRef = useRef();

  const boxOutsideClick = UseOutsideClick(boxRef);

  useEffect(() => {
    if (boxOutsideClick && expandOptions) {
      setExpandOptions(false);
    }
  }, [boxOutsideClick, expandOptions]);

  useEffect(() => {
    if (disabled) {
      setValue("");
      onResetAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  const filteredOptions = useMemo(() => {
    const filtered = options?.filter((el) =>
      el?.name?.toLowerCase()?.includes(value?.toLowerCase())
    );

    // Jika input tidak kosong dan hasil filter kosong, tambahkan opsi baru
    const isNotFound = filtered.length === 0 && value?.trim() !== "";

    return [...filtered, ...(isNotFound ? [{ name: value }] : [])];
  }, [options, value]);

  useEffect(() => {
    if (value) {
      if (!expandOptions) {
        if (
          !options?.find(
            (el) => el?.name?.toLowerCase() === value?.toLowerCase()
          )
        ) {
          if (!forceValue) {
            setValue("");
          }
        } else {
          if (valueLabel) {
            onClickOption(
              options?.find(
                (el) =>
                  el?.name?.toLowerCase() === value?.toLowerCase() &&
                  el?.label?.toLowerCase() === valueLabel?.toLowerCase()
              )
            );
          } else {
            onClickOption(
              options?.find(
                (el) => el?.name?.toLowerCase() === value?.toLowerCase()
              )
            );
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandOptions, options, value, setValue]);

  const [dropdownTop, setDropdownTop] = useState(0);

  useEffect(() => {
    if (boxRef.current) {
      setDropdownTop(boxRef.current.offsetHeight + 8); // 10px untuk gap
    }
  }, [value, expandOptions]); // Update saat input berubah atau dropdown dibuka

  return (
    <div>
      <div
        onClick={() => setExpandOptions(true)}
        className={`${Styles.selectWrapper} ${isError && Styles.isError} ${
          disabled || viewOnly ? Styles.disableInput : ""
        }`}
        ref={boxRef}
      >
        {selectedItem?.length > 0 &&
          selectedItem?.map((el, idx) => {
            return (
              <div className={Styles.selectedItem} key={idx}>
                <span>{el?.name}</span>
                <div onClick={() => onReset(el)}>
                  <Icon icon={"cross"} size={16} color={"#000"} />
                </div>
              </div>
            );
          })}
        <input
          value={value || ""}
          onChange={(e) => {
            setExpandOptions(true);
            setValue(e?.target?.value);
          }}
          onKeyDown={onKeyDown}
          //   style={{ paddingLeft: inputPaddingLeft }}
          placeholder={placeholder}
          disabled={disabled || viewOnly}
          className={`${disabled || viewOnly ? Styles.disableInput : ""}`}
          type="text"
        />

        {expandOptions && !disabled && !viewOnly && value && (
          <div
            className={`${Styles.optionsWrapper}`}
            style={{ top: `${dropdownTop}px`, maxHeight: maxHeight }}
          >
            {filteredOptions?.length > 0 ? (
              filteredOptions?.map((el, idx) => {
                return (
                  <span
                    key={idx}
                    onClick={(e) => {
                      e?.preventDefault();
                      e?.stopPropagation();
                      onClickOption(el);
                      setValue("");
                    }}
                  >
                    {el?.name}
                  </span>
                );
              })
            ) : (
              <div>{"no option"}</div>
            )}
          </div>
        )}
      </div>

      {isErrorText && isError ? (
        <span className={Styles.errorDesc}>{isErrorText}</span>
      ) : null}
    </div>
  );
}
